import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CrearGestion from "./CrearGestion";
import AccionMejora from "./AccionMejora";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import ActualizaEstadoOmEvaluador from "../Evaluador/ActualizaOmNoAgrupadaEva";
import EnviarInformeOmGestion from "./InformeOm";
import DetalleOmAgrupada from "./DetalleAgrupada";
import { useParams } from "react-router-dom";

function OmAgrupadas() {
  const cookie = useMemo(() => new Cookies(), []);
  const [list1, setList1] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { idInstitucion } = useParams();

  // ==========================================
  // Configuración de autorización
  // ==========================================
  const authConfig = useMemo(
    () => ({
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
    }),
    [],
  );

  // ==========================================
  // Construcción del endpoint según el usuario
  // ==========================================
  const urlendpoint = useMemo(() => {
    const tipoUsuario = Number(cookie.get("tipo_Usuario"));

    console.log("TIPO USUARIO:", tipoUsuario);

    if (tipoUsuario == 1 || tipoUsuario == 6) {
      return "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraAgrupacion/1/0";
    }

    if (tipoUsuario == 4) {
      return "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejora/0";
    }

    if (tipoUsuario == 3) {
      return (
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraAgrupacion/1/" +
        idInstitucion
      );
    }

    if (tipoUsuario == 2) {
      const institucionId = cookie.get("institucionid");

      console.log("INSTITUCIÓN:", institucionId);

      return `https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraAgrupacion/1/${institucionId}`;
    }

    return null;
  }, [cookie, idInstitucion]);

  // ==========================================
  // Consumo del API
  // ==========================================
  useEffect(() => {
    let cancelado = false;

    const cargarOportunidades = async () => {
      if (!urlendpoint) {
        setList1([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);

      try {
        const response = await axios.get(urlendpoint, authConfig);

        console.log("Respuesta API completa:", response.data);

        const respuesta = response.data;

        if (!Array.isArray(respuesta)) {
          console.warn("La API no devolvió un arreglo:", respuesta);

          if (!cancelado) {
            setList1([]);
          }

          return;
        }

        // ==========================================
        // Normalizar la respuesta del API
        // Soporta tanto objetos anidados como planos.
        // ==========================================
        const oportunidades = respuesta.map((item) => {
          if (item?.oportunidad) {
            return {
              ...item.oportunidad,
              nombreInstitucion:
                item.nombreInstitucion ||
                item.oportunidad.nombreInstitucion ||
                "",
            };
          }

          return {
            ...item,
            nombreInstitucion:
              item?.nombreInstitucion ||
              item?.razon_Social ||
              item?.razonSocial ||
              "",
          };
        });

        console.log("Oportunidades normalizadas:", oportunidades);

        if (!cancelado) {
          setList1(oportunidades);
        }
      } catch (error) {
        console.error(
          "Error al cargar oportunidades agrupadas:",
          error.response?.data || error.message,
        );

        if (!cancelado) {
          setList1([]);
        }
      } finally {
        if (!cancelado) {
          setIsLoading(false);
        }
      }
    };

    cargarOportunidades();

    return () => {
      cancelado = true;
    };
  }, [urlendpoint, authConfig]);

  // ==========================================
  // Columnas de la tabla
  // ==========================================
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
      },
      {
        Header: "Estado Oportunidad",
        accessor: "estadoOportunidad",
      },

      {
        Header: "Descripción",
        accessor: "descripcion",
        Cell: ({ value }) => {
          const [expandido, setExpandido] = React.useState(false);
          const descripcion = value || "Sin descripción";
          const limite = 100;

          const esLarga = descripcion.length > limite;

          return (
            <div style={{ minWidth: "220px", maxWidth: "350px" }}>
              <span style={{ fontSize: "14px", whiteSpace: "pre-wrap" }}>
                {expandido || !esLarga
                  ? descripcion
                  : `${descripcion.substring(0, limite)}...`}
              </span>

              {esLarga && (
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0 ml-1"
                  onClick={() => setExpandido(!expandido)}
                  style={{ fontSize: "13px", display: "block" }}
                >
                  {expandido ? "Ver menos" : "Ver más"}
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Institución",
        accessor: "nombreInstitucion",
        Cell: ({ value }) => (
          <span style={{ fontSize: "14px" }}>
            {value || "Nombre no disponible"}
          </span>
        ),
      },

      {
        Header: "Añadir",
        Cell: ({ row }) =>
          Number(cookie.get("tipo_Usuario")) === 2 ? (
            <CrearGestion
              descripcion={row.original.descripcion}
              idOm={row.original.id}
            />
          ) : null,
      },
      {
        Header: "Hallazgo evaluador",
        Cell: ({ row }) => (
          <ActualizaEstadoOmEvaluador idOm={row.original.id} />
        ),
      },
      {
        Header: "Consulta Grupo",
        Cell: ({ row }) => <DetalleOmAgrupada idOm={row.original.id} />,
      },
      {
        Header: "Gestiones",
        Cell: ({ row }) => <AccionMejora idOm={row.original.id} />,
      },
    ],
    [cookie],
  );

  // ==========================================
  // Datos para react-table
  // ==========================================
  const data = useMemo(() => (Array.isArray(list1) ? list1 : []), [list1]);

  // ==========================================
  // React Table: filtro y paginación
  // ==========================================
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
    state: { globalFilter },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 10,
      },
    },
    useGlobalFilter,
    usePagination,
  );

  // ==========================================
  // Cargando información
  // ==========================================
  if (isLoading) {
    return <div className="text-center mt-5">Cargando información...</div>;
  }

  // ==========================================
  // Renderizado
  // ==========================================
  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Información de OM agrupadas
            {idInstitucion ? ` - Institución ${idInstitucion}` : ""}
          </h6>
        </div>

        <div className="card-body">
          <EnviarInformeOmGestion />

          <hr />

          <input
            type="text"
            placeholder="Buscar por institución, descripción, estado..."
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="form-control mb-3"
          />

          <div className="table-responsive">
            <table
              {...getTableProps()}
              className="table table-bordered table-hover"
            >
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => {
                  const { key, ...headerGroupProps } =
                    headerGroup.getHeaderGroupProps();

                  return (
                    <tr key={key} {...headerGroupProps}>
                      {headerGroup.headers.map((column) => {
                        const { key: columnKey, ...columnProps } =
                          column.getHeaderProps();

                        return (
                          <th key={columnKey} {...columnProps}>
                            {column.render("Header")}
                          </th>
                        );
                      })}
                    </tr>
                  );
                })}
              </thead>

              <tbody {...getTableBodyProps()}>
                {page.length > 0 ? (
                  page.map((row) => {
                    prepareRow(row);

                    const { key, ...rowProps } = row.getRowProps();

                    return (
                      <tr key={key} {...rowProps}>
                        {row.cells.map((cell) => {
                          const { key: cellKey, ...cellProps } =
                            cell.getCellProps();

                          return (
                            <td key={cellKey} {...cellProps}>
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      No hay registros disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              onClick={previousPage}
              disabled={!canPreviousPage}
              className="btn btn-primary"
            >
              Anterior
            </button>

            <span>
              Página de resultados:{" "}
              {page.length > 0 ? "con registros" : "vacía"}
            </span>

            <button
              onClick={nextPage}
              disabled={!canNextPage}
              className="btn btn-primary"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OmAgrupadas;
